import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../components/FormikControl/FormikControl';
import projectServices from '../projectServices';
import { useAlert } from '../../../../../context/AlertContext';
import { useAppData } from '../../../../../context/AppDataContext';


function ProjectForm({data,callBack }) {

    const {AppAlert} = useAlert();
    const {customerDD,userDD, projectLocationDD} = useAppData();

    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const initialValues = {
        title:"",
        details:"",
        customerId:"",
        managerId:"",
        projectLocationId:"",
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            title:data.title,
            details:data.details,
            customerId:data.customerId,
            managerId:data.managerId,
            projectLocationId:data.projectLocationId,
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        title:Yup.string().required("Required"),
        details:Yup.string().required("Required"),
        customerId:Yup.string().required("Required"),
        managerId:Yup.string().required("Required"),
        projectLocationId:Yup.string().required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        projectServices.save(values).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Add New Project</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{"Add New"}</DialogTitle>
                                    <DialogContent>
                                            <div className="row p-3">

                                                <div className='col-md-4 my-2'>
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Select Customer" name="customerId"  
                                                        options={customerDD} multiple={false} 
                                                    />
                                                </div>

                                                <div className='col-md-4 my-2'>
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Select Project Manager" name="managerId"  
                                                        options={userDD} multiple={false} 
                                                    />
                                                </div>

                                                <div className='col-md-4 my-2'>
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Select Project Location" name="projectLocationId"  
                                                        options={projectLocationDD} multiple={false} 
                                                    />
                                                </div>

                                                <div className="col-md-12 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Project Name" name="title"   
                                                    />
                                                </div>
                                                <div className="col-md-12 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" multiline rows={10}
                                                        label="Project Details" name="details"   
                                                    />
                                                </div>
                                            </div>
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" disabled={!formik.isValid}  type="submit">Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik.values)  */}
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default ProjectForm